var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartContainer',[_c('template',{slot:"chart"},[_c('Chart',{attrs:{"data":_vm.chartData,"hasSettings":true,"labels":_vm.labels,"options":_vm.options,"type":"pie"}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }